//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TooltipEx from "@/components/TooltipEx.vue";
export default {
  name: "MemberOrderGoods",
  components: {
    TooltipEx: TooltipEx
  },
  props: {
    detail: {
      type: Object,
      default: function _default() {}
    },
    current: {}
  }
};